import _objectSpread from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
 *  local storage(web/react native) wrapper
 *  sunnylqm
 */
import { NotFoundError, ExpiredError } from './error';

var Storage =
/*#__PURE__*/
function () {
  function Storage() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Storage);

    this._SIZE = options.size || 1000; // maximum capacity

    this.sync = options.sync || {}; // remote sync method

    this.defaultExpires = options.defaultExpires !== undefined ? options.defaultExpires : 1000 * 3600 * 24;
    this.enableCache = options.enableCache !== false;
    this._s = options.storageBackend || null;
    this._innerVersion = 11;
    this.cache = {};

    if (this._s && this._s.setItem) {
      try {
        var promiseTest = this._s.setItem('__react_native_storage_test', 'test');

        this.isPromise = !!(promiseTest && promiseTest.then);
      } catch (e) {
        console.warn(e);
        delete this._s;
        throw e;
      }
    } else {
      console.warn("Data would be lost after reload cause there is no storageBackend specified!\n      \nEither use localStorage(for web) or AsyncStorage(for React Native) as a storageBackend.");
    }

    this._mapPromise = this.getItem('map').then(function (map) {
      _this._m = _this._checkMap(map && JSON.parse(map) || {});
    });
  }

  _createClass(Storage, [{
    key: "getItem",
    value: function getItem(key) {
      return this._s ? this.isPromise ? this._s.getItem(key) : Promise.resolve(this._s.getItem(key)) : Promise.resolve();
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return this._s ? this.isPromise ? this._s.setItem(key, value) : Promise.resolve(this._s.setItem(key, value)) : Promise.resolve();
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return this._s ? this.isPromise ? this._s.removeItem(key) : Promise.resolve(this._s.removeItem(key)) : Promise.resolve();
    }
  }, {
    key: "_initMap",
    value: function _initMap() {
      return {
        innerVersion: this._innerVersion,
        index: 0,
        __keys__: {}
      };
    }
  }, {
    key: "_checkMap",
    value: function _checkMap(map) {
      if (map && map.innerVersion && map.innerVersion === this._innerVersion) {
        return map;
      } else {
        return this._initMap();
      }
    }
  }, {
    key: "_getId",
    value: function _getId(key, id) {
      return key + '_' + id;
    }
  }, {
    key: "_saveToMap",
    value: function _saveToMap(params) {
      var key = params.key,
          id = params.id,
          data = params.data,
          newId = this._getId(key, id),
          m = this._m;

      if (m[newId] !== undefined) {
        // update existing data
        if (this.enableCache) this.cache[newId] = JSON.parse(data);
        return this.setItem('map_' + m[newId], data);
      }

      if (m[m.index] !== undefined) {
        // loop over, delete old data
        var oldId = m[m.index];
        var splitOldId = oldId.split('_');
        delete m[oldId];

        this._removeIdInKey(splitOldId[0], splitOldId[1]);

        if (this.enableCache) {
          delete this.cache[oldId];
        }
      }

      m[newId] = m.index;
      m[m.index] = newId;
      m.__keys__[key] = m.__keys__[key] || [];

      m.__keys__[key].push(id);

      if (this.enableCache) {
        var cacheData = JSON.parse(data);
        this.cache[newId] = cacheData;
      }

      var currentIndex = m.index;

      if (++m.index === this._SIZE) {
        m.index = 0;
      }

      this.setItem('map_' + currentIndex, data);
      this.setItem('map', JSON.stringify(m));
    }
  }, {
    key: "save",
    value: function save(params) {
      var _this2 = this;

      var key = params.key,
          id = params.id,
          data = params.data,
          rawData = params.rawData,
          _params$expires = params.expires,
          expires = _params$expires === void 0 ? this.defaultExpires : _params$expires;

      if (key.toString().indexOf('_') !== -1) {
        console.error('Please do not use "_" in key!');
      }

      var dataToSave = {
        rawData: data
      };

      if (data === undefined) {
        if (rawData !== undefined) {
          console.warn('"rawData" is deprecated, please use "data" instead!');
          dataToSave.rawData = rawData;
        } else {
          console.error('"data" is required in save()!');
          return;
        }
      }

      var now = Date.now();

      if (expires !== null) {
        dataToSave.expires = now + expires;
      }

      dataToSave = JSON.stringify(dataToSave);

      if (id === undefined) {
        if (this.enableCache) {
          var cacheData = JSON.parse(dataToSave);
          this.cache[key] = cacheData;
        }

        return this.setItem(key, dataToSave);
      } else {
        if (id.toString().indexOf('_') !== -1) {
          console.error('Please do not use "_" in id!');
        }

        return this._mapPromise.then(function () {
          return _this2._saveToMap({
            key: key,
            id: id,
            data: dataToSave
          });
        });
      }
    }
  }, {
    key: "getBatchData",
    value: function getBatchData(querys) {
      var _this3 = this;

      return Promise.all(querys.map(function (query) {
        return _this3.load(query);
      }));
    }
  }, {
    key: "getBatchDataWithIds",
    value: function () {
      var _getBatchDataWithIds = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(params) {
        var _this4 = this;

        var key, ids, syncInBackground, syncParams, tasks, results, missingIds, syncData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = params.key, ids = params.ids, syncInBackground = params.syncInBackground, syncParams = params.syncParams;
                tasks = ids.map(function (id) {
                  return _this4.load({
                    key: key,
                    id: id,
                    syncInBackground: syncInBackground,
                    autoSync: false,
                    batched: true
                  });
                });
                _context.next = 4;
                return Promise.all(tasks);

              case 4:
                results = _context.sent;
                missingIds = [];
                results.forEach(function (value) {
                  if (value.syncId !== undefined) {
                    missingIds.push(value.syncId);
                  }
                });

                if (!missingIds.length) {
                  _context.next = 14;
                  break;
                }

                _context.next = 10;
                return this.sync[key]({
                  id: missingIds,
                  syncParams: syncParams
                });

              case 10:
                syncData = _context.sent;
                return _context.abrupt("return", results.map(function (value) {
                  return value.syncId ? syncData.shift() : value;
                }));

              case 14:
                return _context.abrupt("return", results);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBatchDataWithIds(_x) {
        return _getBatchDataWithIds.apply(this, arguments);
      }

      return getBatchDataWithIds;
    }()
  }, {
    key: "_lookupGlobalItem",
    value: function _lookupGlobalItem(params) {
      var _this5 = this;

      var key = params.key;

      if (this.enableCache && this.cache[key] !== undefined) {
        return this._loadGlobalItem(_objectSpread({
          ret: this.cache[key]
        }, params));
      }

      return this.getItem(key).then(function (ret) {
        return _this5._loadGlobalItem(_objectSpread({
          ret: ret
        }, params));
      });
    }
  }, {
    key: "_loadGlobalItem",
    value: function _loadGlobalItem(params) {
      var key = params.key,
          ret = params.ret,
          autoSync = params.autoSync,
          syncInBackground = params.syncInBackground,
          syncParams = params.syncParams;

      if (ret === null || ret === undefined) {
        if (autoSync && this.sync[key]) {
          return this.sync[key]({
            syncParams: syncParams
          });
        }

        throw new NotFoundError(JSON.stringify(params));
      }

      if (typeof ret === 'string') {
        ret = JSON.parse(ret);

        if (this.enableCache) {
          this.cache[key] = ret;
        }
      }

      var now = Date.now();

      if (ret.expires < now) {
        if (autoSync && this.sync[key]) {
          if (syncInBackground) {
            try {
              this.sync[key]({
                syncParams: syncParams,
                syncInBackground: syncInBackground
              });
            } catch (e) {// avoid uncaught exception
            }

            return ret.rawData;
          }

          return this.sync[key]({
            syncParams: syncParams,
            syncInBackground: syncInBackground
          });
        }

        throw new ExpiredError(JSON.stringify(params));
      }

      return ret.rawData;
    }
  }, {
    key: "_noItemFound",
    value: function _noItemFound(params) {
      var key = params.key,
          id = params.id,
          autoSync = params.autoSync,
          syncParams = params.syncParams;

      if (this.sync[key]) {
        if (autoSync) {
          return this.sync[key]({
            id: id,
            syncParams: syncParams
          });
        }

        return {
          syncId: id
        };
      }

      throw new NotFoundError(JSON.stringify(params));
    }
  }, {
    key: "_loadMapItem",
    value: function _loadMapItem(params) {
      var ret = params.ret,
          key = params.key,
          id = params.id,
          autoSync = params.autoSync,
          batched = params.batched,
          syncInBackground = params.syncInBackground,
          syncParams = params.syncParams;

      if (ret === null || ret === undefined) {
        return this._noItemFound(params);
      }

      if (typeof ret === 'string') {
        ret = JSON.parse(ret);
        var _key = params.key,
            _id = params.id;

        var newId = this._getId(_key, _id);

        if (this.enableCache) {
          this.cache[newId] = ret;
        }
      }

      var now = Date.now();

      if (ret.expires < now) {
        if (autoSync && this.sync[key]) {
          if (syncInBackground) {
            try {
              this.sync[key]({
                id: id,
                syncParams: syncParams,
                syncInBackground: syncInBackground
              });
            } catch (e) {// avoid uncaught exception
            }

            return ret.rawData;
          }

          return this.sync[key]({
            id: id,
            syncParams: syncParams,
            syncInBackground: syncInBackground
          });
        }

        if (batched) {
          return {
            syncId: id
          };
        }

        throw new ExpiredError(JSON.stringify(params));
      }

      return ret.rawData;
    }
  }, {
    key: "_lookUpInMap",
    value: function _lookUpInMap(params) {
      var _this6 = this;

      var ret;
      var m = this._m;
      var key = params.key,
          id = params.id;

      var newId = this._getId(key, id);

      if (this.enableCache && this.cache[newId]) {
        ret = this.cache[newId];
        return this._loadMapItem(_objectSpread({
          ret: ret
        }, params));
      }

      if (m[newId] !== undefined) {
        return this.getItem('map_' + m[newId]).then(function (ret) {
          return _this6._loadMapItem(_objectSpread({
            ret: ret
          }, params));
        });
      }

      return this._noItemFound(_objectSpread({
        ret: ret
      }, params));
    }
  }, {
    key: "remove",
    value: function remove(params) {
      var _this7 = this;

      return this._mapPromise.then(function () {
        var m = _this7._m;
        var key = params.key,
            id = params.id;

        if (id === undefined) {
          if (_this7.enableCache && _this7.cache[key]) {
            delete _this7.cache[key];
          }

          return _this7.removeItem(key);
        }

        var newId = _this7._getId(key, id); // remove existing data


        if (m[newId] !== undefined) {
          if (_this7.enableCache && _this7.cache[newId]) {
            delete _this7.cache[newId];
          }

          _this7._removeIdInKey(key, id);

          var idTobeDeleted = m[newId];
          delete m[newId];

          _this7.setItem('map', JSON.stringify(m));

          return _this7.removeItem('map_' + idTobeDeleted);
        }
      });
    }
  }, {
    key: "_removeIdInKey",
    value: function _removeIdInKey(key, id) {
      var indexTobeRemoved = (this._m.__keys__[key] || []).indexOf(id);

      if (indexTobeRemoved !== -1) {
        this._m.__keys__[key].splice(indexTobeRemoved, 1);
      }
    }
  }, {
    key: "load",
    value: function load(params) {
      var _this8 = this;

      var key = params.key,
          id = params.id,
          _params$autoSync = params.autoSync,
          autoSync = _params$autoSync === void 0 ? true : _params$autoSync,
          _params$syncInBackgro = params.syncInBackground,
          syncInBackground = _params$syncInBackgro === void 0 ? true : _params$syncInBackgro,
          syncParams = params.syncParams,
          batched = params.batched;
      return this._mapPromise.then(function () {
        if (id === undefined) {
          return _this8._lookupGlobalItem({
            key: key,
            autoSync: autoSync,
            syncInBackground: syncInBackground,
            syncParams: syncParams
          });
        } else {
          return _this8._lookUpInMap({
            key: key,
            id: id,
            autoSync: autoSync,
            syncInBackground: syncInBackground,
            batched: batched,
            syncParams: syncParams
          });
        }
      });
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._s.clear && this._s.clear();
      this._m = this._initMap();
    }
  }, {
    key: "clearMap",
    value: function clearMap() {
      var _this9 = this;

      return this.removeItem('map').then(function () {
        _this9.cache = {};
        _this9._m = _this9._initMap();
      });
    }
  }, {
    key: "clearMapForKey",
    value: function clearMapForKey(key) {
      var _this10 = this;

      return this._mapPromise.then(function () {
        var tasks = (_this10._m.__keys__[key] || []).map(function (id) {
          return _this10.remove({
            key: key,
            id: id
          });
        });
        return Promise.all(tasks);
      });
    }
  }, {
    key: "getIdsForKey",
    value: function getIdsForKey(key) {
      var _this11 = this;

      return this._mapPromise.then(function () {
        return _this11._m.__keys__[key] || [];
      });
    }
  }, {
    key: "getAllDataForKey",
    value: function getAllDataForKey(key, options) {
      var _this12 = this;

      options = Object.assign({
        syncInBackground: true
      }, options);
      return this.getIdsForKey(key).then(function (ids) {
        var querys = ids.map(function (id) {
          return {
            key: key,
            id: id,
            syncInBackground: options.syncInBackground
          };
        });
        return _this12.getBatchData(querys);
      });
    }
  }]);

  return Storage;
}();

export { Storage as default };